export function initHeaderMobileMenu(){
    const body = document.body;

    const openBtn = document.querySelector<HTMLButtonElement>('.hamburger');
    const closeBtn = document.querySelector<HTMLButtonElement>('.close-menu');

    openBtn?.addEventListener('click', () => {
        body.classList.add('show-menu');
    });

    closeBtn?.addEventListener('click', () => {
        body.classList.remove('show-menu');
    });
}